import SiteFooter from "./SiteFooter";
import SiteHeader from "./SiteHeader";

function SiteLayout({ children }) {
  return (
    <div className="site">
      <SiteHeader />
      <main className="site-main" id="main-content">
        {children}
      </main>
      <SiteFooter />
    </div>
  );
}

export default SiteLayout;
